<template>
  <div id="app" >


    <div id="page" :class="{menushow:HeaderMShow}">
      <div id="scroller-wrapper" data-scrollbar >
        <home-Component ></home-Component>
      </div>
    </div>


  </div>
</template>

<script>
  import  {WOW} from 'wowjs'
  import Scrollbar from 'smooth-scrollbar';
  import homeComponent from '@/views/index.vue'
  import { setTimeout } from 'timers';
  export default {
    name: 'home',
    data(){
      return{
        wow:'',
        scrollbar:'',
        HeaderMShow: false
      }
    },
    // watch:{
    //   '$route':'init'
    // },
    components:{homeComponent},
    mounted() {
      this.wow=new WOW();
      this.init()
    },
    methods:{
      menushow(HeaderMShow){
        this.HeaderMShow=HeaderMShow
      },
      init(){
        this.$nextTick(()=>{
          this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
          this.wow.init()
          let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
          scrollbar.scrollTo(0,0)
          window.pageYOffset=this.scrollbar.scrollTop
          this.scrollbar.addListener(() => {
            this.wow.scrollHandler()
            window.pageYOffset=this.scrollbar.scrollTop
          });
        })
      }
    }
  }
</script>
<style>
  body{
    margin: 0;
    padding: 0;
  }
  input[type=radio]:checked:before {
    transform: scale(1);
    background: #00A2E9;
  }
  ul,li,p,a{
    margin: 0;
    padding: 0;
    text-decoration: none;
    color:black;
  }
  input:focus {
    border-color: #DCDFE6 !important;
    outline: 0;
  }
  textarea:focus{
    border-color: #DCDFE6 !important;
    outline: 0;
    resize: none !important;
  }
  .donghua{
    height:100vh;
    width:100%;
    position: absolute;
    top:0;
    left:0;
    z-index: 999;
    color:white;
    background-color: black;
    animation-duration: 600ms;
    animation-delay: 100ms;
  }
  #app {
    font-family: "Source Sans Pro", Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width:100%;
    overflow: hidden;
  }
  #page{
    transition: .4s;
    position: relative;
    z-index: 102;
  }
  /*#page.menushow{*/
  /*  transform: translate(0,50vh);*/
  /*}*/
  #scroller-wrapper{
    position: relative;
    height: 100vh;
    overflow: hidden;
    /* z-index: 101; */
  }
  .scrollbar-thumb{
    width:3px !important;
    background-color: #98A48E!important;
  }
  .scrollbar-track-y{
    width:3px !important;
  }
  .fade-enter-active{
    /*进入动画*/
    opacity: 0;
    transform: translateX(100%);
  }
  .fade-leave-active{
    /*离开动画*/
    opacity: 0;
    transform: translateX(-100%);
    position: absolute;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
